import React, { useState } from 'react';
import { Marker as GoogleMarker, InfoWindow } from '@react-google-maps/api';

function Marker({
  marker,
  onClick,
  onClose,
  renderExtraInfo,
  isSelected,
  ...googleMarkerProps
}) {
  const [opacity, setOpacity] = useState(marker.opacity || 1);

  return (
    <GoogleMarker
      key={marker.key}
      position={marker.position}
      onClick={onClick}
      icon={marker.markerStyle}
      zIndex={marker.zIndex}
      opacity={opacity}
      onMouseOver={() => setOpacity(1)}
      onMouseOut={() => setOpacity(marker.opacity)}
      {...googleMarkerProps}
    >
      {isSelected && (
        <InfoWindow onCloseClick={onClose}>
          <div>
            {marker.infoTitle}
            {renderExtraInfo && renderExtraInfo()}
          </div>
        </InfoWindow>
      )}
    </GoogleMarker>
  );
}

export default Marker;
